import { Button, Stack, Typography, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { ArrowCircleLeft, ArrowCircleRight } from '@mui/icons-material';
import { DatePicker } from 'rsuite';
import { enqueueSnackbar } from 'notistack';
import MerchantsTable from './MerchantsTable';
import { format } from "date-fns";
import { useLoaderData } from 'react-router-dom';

const MerchantTabContent = ({
    tab,
    date,
    setDate,
    columns,
    rows,
    selectedProfitCenter,
    selectedMerchantProvider
}) => {

    const { Previlage } = useLoaderData();
    const [draftDate, setDraftDate] = useState(date);
    const isDateEmpty = !draftDate;

    useEffect(() => {
        setDraftDate(date);
    }, [date]);

    const handlePrev = () => {
        if (!Previlage?.[0].Create) {
            enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
            return;
        }
        if (isDateEmpty) {
            enqueueSnackbar("Please select month & year", { variant: "warning" });
            return;
        }
        const prev = new Date(date);
        prev.setMonth(prev.getMonth() - 1);
        setDate(prev);
    };

    const handleNext = () => {
        if (!Previlage?.[0].Create) {
            enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
            return;
        }
        if (isDateEmpty) {
            enqueueSnackbar("Please select the date", { variant: "warning" });
            return;
        }
        const next = new Date(date);
        next.setMonth(next.getMonth() + 1);
        setDate(next);
    };


    return (
        <Stack width={"100%"} height={"100%"}>
            <Stack direction={"row"} alignItems="center" justifyContent={"space-between"}>
                <Stack direction={"row"} alignItems={'center'}>
                    <IconButton onClick={handlePrev} disabled={isDateEmpty}>
                        <ArrowCircleLeft sx={{ color: "black", fontSize: "20px" }} />
                    </IconButton>

                    <Typography fontSize={11} fontWeight={500}>
                        Previous Month
                    </Typography>
                </Stack>

                <Stack direction={'row'} gap={5} alignItems={"center"}>
                    <Stack direction={"row"} alignItems={"center"} gap={1}>
                        <Typography fontSize={12} fontWeight={500}>
                            Select Month & Year
                        </Typography>
                        <DatePicker
                            size='sm'
                            oneTap
                            format="MM-yyyy"
                            editable={false}
                            value={date}
                            // onChange={setDate}
                            onChange={(value) => {
                                if (!Previlage?.[0].Create) {
                                    enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
                                    return;
                                }
                                setDate(value);
                            }}
                            cleanable={false}
                            menuStyle={{ fontFamily: "Poppins" }}
                        />
                    </Stack>
                    <Stack direction={"row"} alignItems={"center"}>
                        <Typography fontSize={11} fontWeight={500}>
                            Next Month
                        </Typography>

                        <IconButton onClick={handleNext} >
                            <ArrowCircleRight sx={{ color: "black", fontSize: "20px" }} />
                        </IconButton>
                    </Stack>

                </Stack>
            </Stack>

            <MerchantsTable
                columns={columns}
                rows={rows}
                selectedProfitCenter={selectedProfitCenter}
                selectedMerchantProvider={selectedMerchantProvider}
                selectedDate={date}
            />

        </Stack>
    );
};

export default MerchantTabContent;